module.exports = __webpack_public_path__ + "static/media/tulikaa_logo.8aaa99dc.svg";